import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../db";
import styles from "./CheckinList.module.css";
import { ArtBox } from "./ArtBox";

export function CheckinList() {
  const checkins = useLiveQuery(async () => {
    const checkins = await db.checkins.orderBy("time").reverse().toArray();

    return Promise.all(
      checkins.map(async (checkin) => ({
        ...checkin,
        box: await db.boxes.get(checkin.boxId),
        media: (
          await db.media.where({ checkinId: checkin.id }).toArray()
        ).filter((m) => m.file.size),
      }))
    );
  }, []);

  async function handleDelete(checkinId: number) {
    await db.transaction("rw", db.checkins, db.media, async () => {
      await db.media.where({ checkinId }).delete();
      await db.checkins.delete(checkinId);
    });
  }

  return (
    <>
      <ol className={styles.container}>
        {checkins?.map((checkin) => (
          <li key={checkin.id} className={styles.checkin}>
            {checkin.box && (
              <ArtBox
                box={checkin.box}
                media={checkin.media}
                note={checkin.note}
              />
            )}

            <button
              className={styles.deleteButton}
              onClick={() => handleDelete(checkin.id)}
            >
              Delete
            </button>
          </li>
        ))}
      </ol>
    </>
  );
}
